export const KIND_PAGE_PATH = '/kind'
